import React from 'react';
import { useAuth } from './AuthContext';
import googleLogo from '../assets/google-logo.png'; // Update the path based on your file structure
import logo from '../assets/logo.jpg'; // Your logo image
import './Login.css';

const Login = () => {
    const { loginWithGoogle } = useAuth();

    return (
        <div className="login-container">

            {/* Login Card */}
            <div className="login-card">


                {/* Welcome Text */}
                <h1 className="login-title">Welcome</h1>
                <p className="login-subtitle">Login with your Google Account to take the<br/> TrueIN Assessment.</p>

                {/* Google Login Button */}
                <button className="login-button" onClick={loginWithGoogle}>
                    <img src={googleLogo} alt="Google Icon" className="google-icon" />
                    Login with Google
                </button>
            </div>
        </div>
    );
};

export default Login;
